module.exports = __webpack_public_path__ + "static/media/processes.a6155194.png";